//对齐线
const full_screen_banner = {
  namespaced: true,
  state:{
    isRender:true,//控制横幅重新渲染
    swiper:null,
    //高度最小是paddingBottom撑开，但是其中增加挂件后，超过paddingBottom，就要用error_height补差
    mb_add_img_obj:{},//当mb下，添加图片选择默认的过度对象
    full_screen_banner_infor:null

  },
  mutations:{
    set_index(state,i){
      state.index = i;
    },
    set_isRender(state,val){
      state.isRender = val;
    },
    set_mb_add_img_obj(state,val){
      state.mb_add_img_obj = val;
    }

  }
};

export default full_screen_banner;



// WEBPACK FOOTER //
// ./src/vuex/modules/full_screen_banner.js